import * as React from "react";
import { useDispatch } from "@teamprevent/admin-redux";
import { Form, Button, Container, Grid } from "semantic-ui-react";
import { Input } from "@neworbit/simpleui-input";

import { purchaseOrderNumberValidator } from "@teamprevent/common/ohCase/validators/purchaseOrderNumberValidator";

import { updatePurchaseOrderNumber } from "../../ohCase/actions";

export interface CasePurchaseOrderProps {
    caseId: string;
    customerId: string;
    purchaseOrderNumber?: string;
}

const CasePurchaseOrderNumber: React.FC<CasePurchaseOrderProps> = ({
    caseId, customerId, purchaseOrderNumber
}) => {
    const dispatch = useDispatch();

    const [newPurchaseOrderNumber, setNewPurchaseOrderNumber] = React.useState<string>(purchaseOrderNumber);
    const [newPurchaseOrderNumberValid, setNewPurchaseOrderNumberValid] = React.useState<boolean>(true);
    const [submitted, setSubmitted] = React.useState<boolean>(false);

    const onPurchaseOrderNumberSave = async () => {
        setSubmitted(true);

        if (!newPurchaseOrderNumberValid) {
            return;
        }

        await dispatch(updatePurchaseOrderNumber(customerId, caseId, newPurchaseOrderNumber));
    };

    const onPurchaseOrderNumberUpdate = (value: string, valid: boolean) => {
        setNewPurchaseOrderNumber(value);

        setNewPurchaseOrderNumberValid(valid);
    };

    return (
        <Container className={"finance-info-tab"}>
            <Grid>
                <Grid.Row columns="2">
                    <Grid.Column>
                        <Form>
                            <Form.Field>
                                <Input.Text
                                    value={purchaseOrderNumber}
                                    showErrors={submitted}
                                    label="Case Purchase Order Number"
                                    onChange={onPurchaseOrderNumberUpdate}
                                    validation={[purchaseOrderNumberValidator]}
                                />
                            </Form.Field>
                            <Button onClick={onPurchaseOrderNumberSave}>Save</Button>
                        </Form>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        </Container>
    );
};

export { CasePurchaseOrderNumber };
